import moment from 'moment';

/**
 * Filename for a downloaded invoice, quote or credit note:
 *
 *   {client}_{number}_{date}.pdf      e.g.  Elmicom_Pty_Ltd_CRN00007_2026-10-06.pdf
 *
 * Client first so a folder sorts by who it is for, then the number, then an
 * ISO date so files for one client sort chronologically.
 */

// Strip anything awkward in a filename and collapse runs of spaces/underscores.
// The old code used .replace(' ', '_'), which only replaces the FIRST space —
// "Bay Distance Riders" came out as "Bay_Distance Riders".
function slug(value) {
    return String(value == null ? '' : value)
        .trim()
        .replace(/[\\/:*?"<>|]+/g, '')   // characters filesystems reject
        .replace(/[\s_]+/g, '_')
        .replace(/^_+|_+$/g, '');
}

/**
 * @param {object} doc      the invoice / quote / credit note
 * @param {string} client   client name; falls back to the document's `to`
 */
export function documentFilename(doc, client) {
    const d = doc || {};

    const number = d.isCreditNote
        ? (d.creditNoteNumber || d.invoiceNumber)
        : (d.isQuote ? d.quoteNumber : d.invoiceNumber);

    const date = d.invoiceDate && moment(d.invoiceDate).isValid()
        ? moment(d.invoiceDate).format('YYYY-MM-DD')
        : '';

    const parts = [slug(client || d.to), slug(number), date].filter(Boolean);

    // Never return just ".pdf" if everything is missing.
    return (parts.length ? parts.join('_') : 'document') + '.pdf';
}

export default documentFilename;
